import { render, staticRenderFns } from "./priceManagerMatrix.vue?vue&type=template&id=4b7ab401&scoped=true"
import script from "./priceManagerMatrix.vue?vue&type=script&lang=js"
export * from "./priceManagerMatrix.vue?vue&type=script&lang=js"
import style0 from "./priceManagerMatrix.vue?vue&type=style&index=0&id=4b7ab401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ab401",
  null
  
)

export default component.exports